// Visibility has no backend enum: the API filters on the boolean IsHidden column. The UI still
// needs a two-state value it can render as checkboxes and chips, so the mapping owns the
// translation back to that boolean.
export const POLICY_VISIBILITY = {
  Visible: 'visible',
  Hidden: 'hidden',
};

const POLICY_VISIBILITY_MAPPING = [
  { value: POLICY_VISIBILITY.Visible, label: 'Visible', isHidden: false },
  { value: POLICY_VISIBILITY.Hidden, label: 'Hidden', isHidden: true },
];

export const getPolicyVisibilityLabel = value =>
  POLICY_VISIBILITY_MAPPING.find(item => item.value === value)?.label ?? '';

export const getPolicyVisibilityOptions = () =>
  POLICY_VISIBILITY_MAPPING.map(({ value, label }) => ({ value, label }));

export const toIsHiddenValues = visibilities =>
  POLICY_VISIBILITY_MAPPING.filter(item => visibilities.includes(item.value)).map(
    item => item.isHidden,
  );
